import React, { ReactNode } from 'react';
import { RouteComponentProps } from 'react-router';
import JobOfferLayout from '../layout/jobOffer/JobOfferLayout';
import OfferDetails from './view/OfferDetails';
import OfferApplication from './apply/OfferApplication';
import JobOfferApplicationSent from './sent/JobOfferApplicationSent';
import JobOfferSentLayout from '../layout/jobOffer/JobOfferSentLayout';

export const jobOfferRouteRenderer = (props: RouteComponentProps<any>): ReactNode => {
    return (
        <JobOfferLayout>
            <OfferDetails />
        </JobOfferLayout>
    );
};

export const jobOfferApplicationRouteRenderer = (props: RouteComponentProps<any>): ReactNode => {
    return (
        <JobOfferLayout>
            <OfferApplication />
        </JobOfferLayout>
    );
};

export const jobOfferApplicationSentRouteRenderer = (props: RouteComponentProps<any>): ReactNode => {
    return (
        <JobOfferSentLayout>
            <JobOfferApplicationSent />
        </JobOfferSentLayout>
    );
};
